import { MetaData } from '../../types/content-page'

export default (country: string, metaData?: MetaData): string => {
  if (metaData) {
    return metaData.metaTitle
      ? metaData.metaTitle
      : `Westfield ${metaData.title}`
  } else {
    return `Westfield ${country}`
  }
}
